import * as React from 'react';
import { PageDescription } from './PageDescription';
import { FacebookMeta } from './FacebookMeta';
import { OpenGraph } from './OpenGraph';
import { TwitterShare } from './TwitterShare';
import { ItemsListSchema } from './ItemsListSchema';
import { createImageAttributes, PageImage } from './metaTags.utils';
import { CardComponentDataProps } from '../partials/cards/cards.utils';

interface MetaHeaderTagsProps {
  canonicalUrl: string;
  favicon: string;
  description: string;
  facebookAppId: string | null;
  facebookPageId: string | null;
  title: string;
  twitterAccount: string | null;
  siteName: string;
  pageImage: PageImage | null;
  articles: Array<CardComponentDataProps>;
  logoUrl: string;
  ampURL: string | null;
  prevCanonicalUrl: string | null;
}
export const MetaHeaderTags: React.FunctionComponent<MetaHeaderTagsProps> = ({ canonicalUrl, favicon, description, facebookAppId, facebookPageId, title, twitterAccount, siteName, pageImage, articles, logoUrl, ampURL, prevCanonicalUrl }) => {
  const { imageHeight = null, imageUrl = null, imageWidth = null } = pageImage ? createImageAttributes(pageImage) : {};
  return (
    <React.Fragment>
      <PageDescription pageUrl={canonicalUrl} favicon={favicon} description={description} title={title} ampURL={ampURL} prevCanonicalUrl={prevCanonicalUrl} />
      <FacebookMeta appId={facebookAppId} pageId={facebookPageId} />
      <OpenGraph pageUrl={canonicalUrl} image={imageUrl} title={title} siteName={siteName} imageHeight={imageHeight} imageWidth={imageWidth} description={description} />
      <TwitterShare title={title} description={description} account={twitterAccount} image={imageUrl} pageUrl={canonicalUrl} imageHeight={imageHeight} imageWidth={imageWidth} />
      <ItemsListSchema publisherName={siteName} logoUrl={logoUrl} itemListElement={articles} />
    </React.Fragment>
  );
};
